/**
 * Display a choice with a picture, a name, description and price
 * shape parameter allow to show image as a cicle or a square
 */
fx.ns("shared.components", class PosterFrameChoice extends fx.components.VBox
{    
    constructor(data, name, text, price, notAvailable)
    {
        super(data);
        this.name = name;
        this.text = text;
        this.price = price;
        this.notAvailable = notAvailable;
    }

     frameAsset(option)
    {
        switch(option.editor_code)
        {
            case "wood" : 
                return fx.assets.frameWood;

            case "black" : 
                return fx.assets.frameBlack;

            case "white" : 
                return fx.assets.frameWhite;

            case "standard" : 
                return fx.assets.posterWhite;
        }
    }

    create()
    {
        super.create();
        
        let posterContainer = new fx.components.Box("poster-container");
        //let whitePoster = new fx.components.Box("white-poster");
        //whitePoster.addChild( new fx.components.Text({text : this.description, className : "description"}), {width : "auto", height : "auto", left : "center", top : "center"});
        //posterContainer.addChild( whitePoster, { width : this.posterSize.width, height : this.posterSize.height, top : "center", left : "center"} );
        posterContainer.addChild( new fx.components.Image(this.frameAsset(this.data.option)), { width : "100%", height : "100%"} );

        this.addChild( posterContainer, { width : "100%", height : 300});
        
        let bottomContainer = new fx.components.VBox("bottom-container");

        if (this.name)
            bottomContainer.addChild( new fx.components.Text( {text : this.name, className : "name"} ), {width:"auto", height : "auto", left : "center"} );

        if (this.text)
            bottomContainer.addChild( new fx.components.Text( {text : this.text, className : "description"} ), {width:"auto", height : "auto", left : "center"} );

        if (this.price)
            bottomContainer.addChild( new fx.components.Text( {text : this.price, className : "price"} ), {width:"auto", left : "center"} );

        if (this.notAvailable)
            bottomContainer.addChild( new fx.components.Text( {text : fx.text("Non disponible"), className : "availability"} ), {width:"auto", left : "center"} );

        this.addChild(bottomContainer, { width : "100%", height : "auto"});
    }

});
